import { networkClient } from "./networkClient";

export const START_CHECKOUT = "/subscription/checkout";

export const startCheckoutApi = async ({ priceId }: any) => {
  const { data } = await networkClient.post(START_CHECKOUT, { priceId });
  return data;
};
